import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "plugImage",
  listPath: "plug/image",
  adminPath: "plug/image",
  legacy: {
    data: "plugImage",
    count: "count",
    fetch: "fetchPlugImages",
    create: "createOnePlugImage",
    update: "updatePlugImage",
    remove: "deletePlugImage",
    updateState: "updatePlugImageState",
  },
});

export const PlugImageProvider = Provider;
export const usePlugImageContext = useValue;
